import { useMemo } from 'react'

import { MainContent, ModalContext, TopBar } from '@domain-group/suit-theme'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'

import PageContext from '@contexts/pageContext'

import useMainNavigation from '@hooks/useMainNavigation'
import usePublications from '@hooks/usePublications'

import handleCallbackAction from '@functions/handleCallbackAction'
import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import AssignLayoutTemplatePermissionsModal from '@modals/AssignLayoutTemplatePermissionsModal'

import LoggedInUser from '@components/LoggedInUser'
import MainNavigation from '@sections/Admin/components/MainNavigation'

import PageContent from './components/PageContent'

import defaultRequestOptions from '../../defaultRequestOptions'

export type PageContextPayload = {
  callbacks: {
    resetFilters: () => void,
    showCreateOrEditTaskListModal: (payload: object) => void,
    showCreateTemplateGroupModal: () => void,
    updateFilters: (filters: object) => void,
  },
  defaultFilters: object,
}

// @ts-expect-error TS2304
const callbacks = (component: keyof typeof componentCallbacks, setState: SetState) => {
  const componentCallbacks = {
    AssignLayoutTemplatePermissionsModal: {
      closeModal: () => setState({ showAssignLayoutTemplatePermissionsModal: false }),
      updateCompatibleProducts: (payload: HandleCallbackActionParams) => handleCallbackAction({ ...payload, requestOptions: defaultRequestOptions.layoutTemplate }),
    },
  }

  return componentCallbacks[component] || {}
}

const defaultState = {
  showAssignLayoutTemplatePermissionsModal: false,
}

const Overview = () => {
  const [state, setState] = useSetState(defaultState)
  const { showAssignLayoutTemplatePermissionsModal } = state

  const { callbacks: { toggleNavigation } } = useMainNavigation()

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    pageFilters,
  } = useFilters()

  const modalContext = useModals()
  const {
    callbacks: { setModalData },
  } = modalContext

  usePublications({ performHttpRequests: true, requestOptions: { include_publication_products: true } })

  // @ts-expect-error TS2322
  const pageContext: PageContextPayload = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      showAssignLayoutTemplatePermissionsModal: (payload: object) => {
        setModalData('AssignLayoutTemplatePermissionsModal', payload)
        setState({ showAssignLayoutTemplatePermissionsModal: true })
      },
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <TopBar
          callbacks={{ toggleNavigation }}
          loggedInUserComponent={<LoggedInUser />}
          // @ts-expect-error TS2322
          searchComponent={<TopBar.Search callbacks={{ search: null }} />}
        />

        {/*
         // @ts-expect-error TS2739 */}
        <MainNavigation />

        <MainContent offset={{ top: TopBar.topBarHeight }}>
          <PageContent pageFilters={pageFilters} />
        </MainContent>

        <AssignLayoutTemplatePermissionsModal
          // @ts-expect-error TS2739
          callbacks={callbacks('AssignLayoutTemplatePermissionsModal', setState)}
          showModal={showAssignLayoutTemplatePermissionsModal}
        />

      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default Overview
